import React from 'react'
import styled from 'styled-components'

export interface CartDetailsContainerProps {
  children: React.ReactNode
  className?: string
}

const CartDetailsContainer: React.FC<CartDetailsContainerProps> = ({ children, className }) => (
  <div className={className}>{children}</div>
)

const StyledCartDetailsContainer = styled(CartDetailsContainer)`
  display: flex;
  flex-direction: column;
  flex: 1;

  h3 {
    margin-top: 40px;
    text-align: center;
  }
`

export default StyledCartDetailsContainer
